import { render, staticRenderFns } from "./CoursewareBlockActions.vue?vue&type=template&id=e36098cc&"
import script from "./CoursewareBlockActions.vue?vue&type=script&lang=js&"
export * from "./CoursewareBlockActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports